import $jg56D$react, {useContext as $jg56D$useContext} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $9f4d05c8f96993f7$export$c7e742effb1c51e2 = (0, $jg56D$react).createContext({});
function $9f4d05c8f96993f7$export$21c7ab35b39f78ec() {
    return (0, $jg56D$useContext)($9f4d05c8f96993f7$export$c7e742effb1c51e2);
}
const $9f4d05c8f96993f7$export$8d97fe02339fc0e3 = (0, $jg56D$react).createContext(undefined);
function $9f4d05c8f96993f7$export$dc2161044aa0b36d() {
    return (0, $jg56D$useContext)($9f4d05c8f96993f7$export$8d97fe02339fc0e3);
}
const $9f4d05c8f96993f7$export$24aad8519b95b41b = (0, $jg56D$react).createContext(undefined);
function $9f4d05c8f96993f7$export$efa3856fc0e85e7f() {
    return (0, $jg56D$useContext)($9f4d05c8f96993f7$export$24aad8519b95b41b);
}


export {$9f4d05c8f96993f7$export$c7e742effb1c51e2 as MenuContext, $9f4d05c8f96993f7$export$21c7ab35b39f78ec as useMenuContext, $9f4d05c8f96993f7$export$8d97fe02339fc0e3 as SubmenuTriggerContext, $9f4d05c8f96993f7$export$dc2161044aa0b36d as useSubmenuTriggerContext, $9f4d05c8f96993f7$export$24aad8519b95b41b as MenuStateContext, $9f4d05c8f96993f7$export$efa3856fc0e85e7f as useMenuStateContext};
//# sourceMappingURL=context.mjs.map
